import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function GloginSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const name = params.get("first_name");  
    const email = params.get("email");
    const id = params.get("id");

    //console.log("LoginSuccess URL Params:", { token, name, email, id });

    if (token && name) {
      // Save to localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("name", name);
      localStorage.setItem("email", email);
      localStorage.setItem("user_id", id);
      
      // Small delay to ensure storage is saved
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 300);
    } else {
      console.warn("Missing token or name, redirecting to login...");
      navigate("/login", { replace: true });
    }

    setLoading(false);
  }, [location, navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      {loading ? "Logging you in..." : "Redirecting..."}
    </div>
  );
}

export default GloginSuccess;
